"use client";

import Link from "next/link";
import { useIsAdmin } from "@/hooks/use-is-admin";

// Client-side check (mirrors GoProLink/ProBadge) so this nav link doesn't force
// every page in the root layout into fully dynamic, uncached rendering via a
// server-side auth() call. Real authorization still happens in
// app/admin/layout.tsx's requireAdmin().
export function AdminNavLink() {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return null;
  return (
    <Link href="/admin" className="text-sm font-medium hover:text-primary transition-colors">
      Admin
    </Link>
  );
}
